<div class="">
  <!--begin::Profile Personal Information-->
  <div class="d-flex flex-row" style="max-height: 100vh">
    <!--begin::Aside-->
    <div class="flex-row-auto w-250px w-xxl-350px" id="kt_profile_aside" *ngIf="patient?.id">
      <!--begin::Profile Card-->
      <div class="card card-custom card-stretch panel_1">
        <!--begin::Body-->
        <div class="card-body" style="padding: 10px; padding-bottom: 0 !important">
          <!--begin::User-->
          <table class="mb-10" style="width: 100%">
            <tr>
              <td class="d-flex align-items-start">
                <span
                  class="symbol symbol-70 symbol-xxl-100 align-self-start align-self-xxl-center"
                >
                  <span>
                    <div>
                      <div class="image-input image-input-outline image-input-changed gl-block">
                        <img
                          class="image-input-wrapper"
                          id="contact_profile"
                          src="{{ patientProfile }}"
                          style="width: 115px; height: 115px"
                          alt="Patient Profile"
                        />
                        <label
                          *ngxPermissionsOnly="canEditPatient"
                          class="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow dropdown-toggle dropdown-toggle-split"
                          data-action="change"
                          data-toggle="dropdown"
                          title=""
                          data-original-title="Change avatar"
                        >
                          <i class="fa fa-pen icon-sm text-muted"></i>
                        </label>
                        <span
                          *ngIf="patient.pre_signed_url?.url"
                          class="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow magnify-icon"
                          data-action="zoom"
                          (click)="showPatientPhoto(patient)"
                          matTooltip="Zoom in"
                        >
                          <i
                            class="flaticon-search-magnifier-interface-symbol icon-nm text-muted"
                          ></i>
                        </span>
                        <div class="dropdown-menu dropdown-menu-sm dropdown-menu-left">
                          <a class="dropdown-item" (click)="updateProfile()"> Upload photo </a>
                          <a
                            *ngIf="patient && patient.id"
                            class="dropdown-item"
                            (click)="viewFiles()"
                          >
                            Previous photos
                          </a>
                        </div>
                      </div>
                    </div>
                  </span>
                </span>
              </td>
              <td>
                <div
                  style="max-width: 240px; overflow: hidden; margin: auto; text-align: left"
                  class="main-cont gl-block pl-5 pr-1"
                >
                  <p
                    class="font-weight-bolder text-dark-75 mb-0 title-one"
                    [innerText]="firstLine()"
                  ></p>
                  <p
                    class="font-weight-bolder text-dark-75 mb-0 title-two"
                    [innerText]="secondLine()"
                  ></p>
                  <p class="text-primary m-0">#{{ basicInfo.id }}</p>
                  <button
                    matTooltip="Start Focused View"
                    class="btn btn-icon btn-light btn-hover-success btn-sm m-1"
                    (click)="openFocusedSelectContact()"
                    *ngIf="!isFocusedView && patient && patient.id"
                  >
                    <span
                      inlineSVG="assets/media/svg/icons/General/focus-svgrepo-com.svg"
                      class="svg-icon svg-icon-md svg-icon-success"
                    ></span>
                  </button>
                </div>
              </td>
            </tr>
          </table>
          <!--end::User-->
          <!--begin::Contact-->
          <div class="mb-7 text-center">
            <div class="dropdown dropdown-inline">
              <a
                class="btn btn-icon btn-circle btn-light-facebook mr-3 dropdown-toggle"
                type="button"
                matTooltip="Cell Phone"
                id="dropdownMenuButton"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <i class="fas fa-mobile-alt icon-md"></i>
              </a>
              <div
                class="dropdown-menu gl-block p-3 contact-info"
                aria-labelledby="dropdownMenuButton"
              >
                {{ patient?.cell_phone ? (patient.cell_phone | mask : '(000) 000-0000') : '-' }}
              </div>
            </div>
            <div class="dropdown dropdown-inline">
              <a
                class="btn btn-icon btn-circle btn-light-twitter mr-3 dropdown-toggle"
                type="button"
                matTooltip="Email"
                id="dropdownMenuButtonEmail"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <i class="fa flaticon-email" aria-hidden="true"></i>
              </a>
              <div
                class="dropdown-menu gl-block p-3 contact-info"
                aria-labelledby="dropdownMenuButtonEmail"
              >
                {{ patient?.email || '-' }}
              </div>
            </div>

            <div class="dropdown dropdown-inline">
              <a
                class="btn btn-icon btn-circle btn-light-google dropdown-toggle"
                type="button"
                matTooltip="Address"
                id="dropdownMenuButtonAddress"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <i class="fa flaticon2-pin" aria-hidden="true"></i>
              </a>
              <div
                class="dropdown-menu gl-block p-3 contact-info"
                aria-labelledby="dropdownMenuButtonAddress"
              >
                {{ addressLine() }}
              </div>
            </div>
          </div>
          <!--end::Contact-->
          <div>
            <div></div>
          </div>
          <!--begin::Contact-->
          <div class="py-3" style="padding-left: 1.5rem; padding-bottom: 0 !important">
            <div
              class="d-flex align-items-center justify-content-left mb-5"
              matTooltip="Date of Birth"
            >
              <span class="font-weight-bold mr-2">
                <i class="fa fa-birthday-cake" aria-hidden="true"></i
              ></span>
              <a class="text-muted text-hover-primary gl-block"
                >{{ basicInfo.dob || '-'
                }}{{
                  ' (' +
                    (basicInfo.dob ? getAge(basicInfo.dob) + 'yrs old ' : '') +
                    (basicInfo.gender | titlecase) +
                    ')'
                }}</a
              >
            </div>
            <div class="d-flex align-items-center justify-content-left mb-5" matTooltip="Facility">
              <span class="font-weight-bold mr-2"> <i class="fa fa-building"></i> </span>
              <a class="text-muted text-hover-primary gl-block">{{
                patient?.facility_name ? (patient.facility_name | titlecase) : '-'
              }}</a>
            </div>
          </div>
          <!--end::Contact-->
        </div>
        <!--end::Body-->
      </div>
      <!--end::Profile Card-->
      <!--begin::Profile Card-->
      <div class="card card-custom card-stretch panel_2" id="panel_2">
        <!--begin::Body-->
        <div class="card-body pt-4">
          <!--begin::Nav-->
          <div class="navi navi-bold navi-hover navi-active navi-link-rounded">
            <ng-container
              *ngFor="let tab of tabs.slice(0, getTabsNumber())"
              [ngTemplateOutlet]="navi_item"
              [ngTemplateOutletContext]="{ tab: tab }"
            ></ng-container>
            <div class="navi-item mb-2 clickable" *ngIf="!(getTabsNumber() >= tabs.length)">
              <a
                class="navi-link py-4 dropdown-toggle"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <span class="navi-icon mr-2">
                  <i class="flaticon-more icon-md"></i>
                </span>
                <span class="navi-text font-size-lg">More</span>
              </a>

              <div
                class="dropdown-menu scroll"
                style="width: 250px; height: 300px"
                [perfectScrollbar]="{ wheelPropagation: false }"
              >
                <ng-container
                  *ngFor="let tab of tabs.slice(getTabsNumber())"
                  [ngTemplateOutlet]="navi_item"
                  [ngTemplateOutletContext]="{ tab: tab }"
                ></ng-container>
              </div>
            </div>
            <ng-template #navi_item let-tab="tab">
              <div *ngxPermissionsOnly="tab.permission" class="navi-item mb-2 clickable">
                <a
                  class="navi-link py-4"
                  [ngClass]="{ active: tab.active }"
                  (click)="changeTab(tab.index)"
                >
                  <span class="navi-icon mr-2">
                    <i class="{{ tab.icon }}"></i>
                  </span>
                  <span
                    class="navi-text font-size-lg"
                    [innerHTML]="tab.label | safe : 'html'"
                  ></span>
                </a>
              </div>
            </ng-template>
          </div>
          <!--end::Nav-->
        </div>
        <!--end::Body-->
      </div>
      <!--end::Profile Card-->
    </div>
    <!--end::Aside-->

    <!--begin::Content-->
    <div
      class="flex-row-fluid"
      [ngStyle]="patient?.id ? { 'margin-left': '8px' } : { 'margin-left': '0' }"
      style="height: 100vh"
    >
      <!--begin::Card-->
      <div class="card card-custom card-stretch" *ngIf="tabs[0].active">
        <!--begin::Header-->
        <div class="card-header py-3">
          <div class="card-title align-items-start flex-column">
            <h3 class="card-label font-weight-bolder text-dark">
              {{
                patient?.id
                  ? (patient.first_name ? patient.first_name : '') +
                    ' ' +
                    (patient.middle_name ? patient.middle_name : '') +
                    ' ' +
                    (patient.last_name ? patient.last_name : '') +
                    ' ' +
                    (patient.last_name2 ? patient.last_name2 : '') +
                    '’s
              Patient Information'
                  : 'New Patient'
              }}
            </h3>
            <span class="text-muted font-weight-bold font-size-sm mt-1"
              >{{ patient?.id ? 'Update ' : 'Add ' }} patient information</span
            >
          </div>
          <div class="card-toolbar">
            <a
              ktBackButton
              class="btn btn-secondary mr-2"
              mat-raised-button
              matTooltip="{{ 'AUTH.INPUT.BACK' | translate }}"
              *ngIf="!entity_id"
            >
              <i class="la la-arrow-left"></i>
              <span class="hidden-mobile"> {{ 'AUTH.INPUT.BACK' | translate }}</span>
            </a>
            <ng-template ngxPermissionsOnly="canEditPatient">
              <a
                *ngIf="isViewMode"
                (click)="editPatient(patient)"
                class="btn btn-secondary mr-2"
                mat-raised-button
                matTooltip="Edit Patient"
              >
                <span class="hidden-mobile" translate="GLOBAL.EDIT">Edit</span>
              </a>
            </ng-template>
            <a
              href="javascript:"
              *ngIf="patient && !patient.id"
              class="btn btn-secondary mr-2"
              (click)="reset()"
              mat-raised-button
              matTooltip="{{ 'AUTH.RESET.BUTTON' | translate }}"
            >
              <i class="la la-cog"></i>
              <span class="hidden-mobile">{{ 'AUTH.RESET.BUTTON' | translate }}</span>
            </a>
            <a
              class="btn btn-primary mr-2"
              *ngIf="!isViewMode"
              color="primary"
              (click)="onSubmit()"
              mat-raised-button
              matTooltip="Save & Continue"
            >
              <span class="hidden-mobile"> {{ 'AUTH.INPUT.SAVE' | translate }}</span>
            </a>
          </div>
        </div>
        <!--end::Header-->

        <!--begin::Form-->
        <form class="form" [formGroup]="patientForm" *ngIf="loadingData" style="overflow-y: scroll">
          <kt-alert
            *ngIf="hasFormErrors"
            type="warn"
            [showCloseButton]="true"
            [duration]="10000"
            (closeAl)="onAlertClose()"
          >
            {{ 'AUTH.VALIDATION.INVALID_OR_REQUIRED' | translate }}
          </kt-alert>
          <kt-alert
            *ngIf="hasSubmissionErrors && !hasFormErrors"
            type="warn"
            [duration]="30000"
            [showCloseButton]="true"
            (closeAl)="onAlertClose()"
          >
            <ul>
              <li *ngFor="let msg of submissionErrorObj">{{ msg.error | translate }}</li>
            </ul>
          </kt-alert>
          <!--begin::Body-->
          <div class="card-body">
            <div class="row">
              <h5 class="font-weight-bold mb-6">Patient Demographics</h5>
            </div>
            <div class="form-group row">
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid gl-block" appearance="fill">
                  <mat-label>{{ 'PATIENT.INPUT.FIRST_NAME' | translate }}</mat-label>
                  <input
                    matInput
                    placeholder="Enter First Name"
                    formControlName="first_name"
                    autocomplete="kt-patient-first-name"
                    required
                  />
                  <mat-error
                    >{{ 'PATIENT.INPUT.FIRST_NAME' | translate }}
                    <strong>{{ 'PATIENT.VALIDATION.REQUIRED' | translate }}</strong>
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid gl-block" appearance="fill">
                  <mat-label>{{ 'PATIENT.INPUT.MIDDLE_NAME' | translate }}</mat-label>
                  <input
                    matInput
                    placeholder="Enter Middle Name"
                    formControlName="middle_name"
                    autocomplete="kt-patient-middle-name"
                  />
                </mat-form-field>
              </div>
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid gl-block" appearance="fill">
                  <mat-label>{{ 'PATIENT.INPUT.LAST_NAME' | translate }}</mat-label>
                  <input
                    matInput
                    placeholder="Enter Last Name"
                    formControlName="last_name"
                    autocomplete="kt-patient-last-name"
                    required
                  />
                  <mat-error
                    >{{ 'PATIENT.INPUT.LAST_NAME' | translate }}
                    <strong>{{ 'PATIENT.VALIDATION.REQUIRED' | translate }}</strong>
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid gl-block" appearance="fill">
                  <mat-label>{{ 'PATIENT.INPUT.LAST_NAME_2' | translate }}</mat-label>
                  <input
                    matInput
                    placeholder="Enter Last Name 2"
                    formControlName="last_name2"
                    autocomplete="kt-patient-last-name-2"
                  />
                </mat-form-field>
              </div>
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid" appearance="fill">
                  <mat-label>{{ 'PATIENT.INPUT.PRIMARY_LANGUAGE' | translate }}</mat-label>
                  <input
                    matInput
                    placeholder="Enter Primary Language"
                    formControlName="primary_language"
                    autocomplete="kt-patient-primary-language"
                  />
                  <mat-error
                    >{{ 'PATIENT.INPUT.PRIMARY_LANGUAGE' | translate }}
                    <strong>{{ 'PATIENT.VALIDATION.REQUIRED' | translate }}</strong>
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-2 kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid" appearance="fill">
                  <mat-label>{{ 'PATIENT.INPUT.GENDER' | translate }}</mat-label>
                  <mat-select formControlName="gender">
                    <mat-option value="MALE"> {{ 'PATIENT.INPUT.MALE' | translate }} </mat-option>
                    <mat-option value="FEMALE">
                      {{ 'PATIENT.INPUT.FEMALE' | translate }}
                    </mat-option>
                    <mat-option value=""> Undefined </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div class="col-lg-2 kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid gl-block" appearance="fill">
                  <mat-label>{{ 'PATIENT.INPUT.DOB' | translate }}</mat-label>
                  <input
                    matInput
                    [matDatepicker]="dob"
                    formControlName="dob"
                    [max]="maxDate"
                    ktDateMaskControl
                    maxlength="10"
                    placeholder="MM/DD/YYYY"
                    autocomplete="kt-patient-dob"
                    (dateChange)="setMaxDate($event)"
                    required
                  />
                  <mat-datepicker-toggle matSuffix [for]="dob"></mat-datepicker-toggle>
                  <mat-datepicker #dob></mat-datepicker>
                  <mat-error *ngIf="isControlHasError('dob', 'required')">
                    {{ 'PATIENT.INPUT.DOB' | translate }}
                    <strong>{{ 'PATIENT.VALIDATION.REQUIRED' | translate }}</strong>
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid gl-block" appearance="fill">
                  <mat-label>{{ 'PATIENT.INPUT.EMAIL' | translate }}</mat-label>
                  <input
                    matInput
                    placeholder="Enter Email"
                    formControlName="email"
                    autocomplete="kt-patient-email"
                  />
                  <mat-error *ngIf="isControlHasError('email', 'required')">
                    {{ 'PATIENT.INPUT.EMAIL' | translate }}
                    <strong>{{ 'PATIENT.VALIDATION.REQUIRED' | translate }}</strong>
                  </mat-error>
                  <mat-error *ngIf="isControlHasError('email', 'email')">
                    {{ 'PATIENT.INPUT.EMAIL' | translate }}
                    <strong>{{ 'PATIENT.VALIDATION.EMAIL' | translate }}</strong>
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid" appearance="fill">
                  <mat-label>{{ 'PATIENT.INPUT.PATIENT_CLASS' | translate }}</mat-label>
                  <input
                    matInput
                    placeholder="Enter Patient Class"
                    formControlName="patient_class"
                    autocomplete="kt-patient-class"
                  />
                  <mat-error
                    >{{ 'PATIENT.INPUT.PATIENT_CLASS' | translate }}
                    <strong>{{ 'PATIENT.VALIDATION.REQUIRED' | translate }}</strong>
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <kt-general-autocomplete
                  [label]="'PATIENT.INPUT.FACILITY' | translate"
                  [loadItemsFunction]="facilityAutocompleteCall"
                  [optionFormatter]="stringUtils.autocompleteEntityFormatter"
                  [valueFormatter]="stringUtils.displayName"
                  [required]="false"
                  [readOnly]="readOnly"
                  [control]="patientForm.get('facility_id')"
                  [change]="onFacilityChange.bind(this)"
                  [placeholder]="'Search Facilities'"
                  [dataPath]="'data'"
                  #facilityAutocomplete
                ></kt-general-autocomplete>
              </div>
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <kt-general-autocomplete
                  [label]="'Species'"
                  [loadItemsFunction]="speciesAutocompleteCall"
                  [optionFormatter]="stringUtils.autocompleteEntityFormatter"
                  [valueFormatter]="stringUtils.displayName"
                  [required]="false"
                  [readOnly]="readOnly"
                  [control]="patientForm.get('species')"
                  [change]="onSpeciesChange.bind(this)"
                  [placeholder]="'Search Species'"
                  [dataPath]="'data'"
                  #speciesAutocomplete
                ></kt-general-autocomplete>
              </div>
              <div class="col-lg kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid" appearance="fill">
                  <mat-label>Deceased</mat-label>
                  <input
                    matInput
                    [matDatepicker]="deceased"
                    formControlName="deceased"
                    ktDateMaskControl
                    maxlength="10"
                    placeholder="MM/DD/YYYY"
                    autocomplete="kt-patient-deceased"
                  />
                  <mat-datepicker-toggle matSuffix [for]="deceased"></mat-datepicker-toggle>
                  <mat-datepicker #deceased></mat-datepicker>
                </mat-form-field>
              </div>
              <div class="col-lg kt-margin-bottom-20-mobile">
                <div class="mat-form-field-fluid">
                  <mat-label class="row ml-1" translate="DOCTOR.INPUT.STATUS">Status</mat-label>
                  <mat-slide-toggle class="mr-2" formControlName="is_active"></mat-slide-toggle>
                  <mat-hint align="start">
                    <strong>{{ getStatusString() }}</strong>
                  </mat-hint>
                </div>
              </div>
            </div>
            <div class="row">
              <h5 class="font-weight-bold mb-6">Contacts</h5>
            </div>
            <div class="form-group row">
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid gl-block" appearance="fill">
                  <mat-label>{{ 'PATIENT.INPUT.CELL_PHONE' | translate }}</mat-label>
                  <input
                    matInput
                    placeholder="{{ 'PATIENT.PLACEHOLDER.CELL_PHONE' | translate }}"
                    formControlName="cell_phone"
                    maxlength="14"
                    ktAppPhoneMask
                    autocomplete="kt-patient-cellphone"
                  />
                  <mat-error *ngIf="isControlHasError('cell_phone', 'pattern')">
                    {{ 'PATIENT.INPUT.CELL_PHONE' | translate }}
                    <strong>{{ 'PATIENT.VALIDATION.PATTERN' | translate }}</strong>
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid gl-block" appearance="fill">
                  <mat-label>{{ 'DOCTOR.INPUT.FAX' | translate }}</mat-label>
                  <input
                    matInput
                    formControlName="fax"
                    maxlength="14"
                    ktAppPhoneMask
                    autocomplete="kt-patient-fax"
                  />
                  <mat-error *ngIf="isControlHasError('fax', 'pattern')">
                    {{ 'AUTH.VALIDATION.PATTERN' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid gl-block" appearance="fill">
                  <mat-label>{{ 'PATIENT.INPUT.HOME_PHONE' | translate }}</mat-label>
                  <input
                    matInput
                    placeholder="Enter Home Phone"
                    formControlName="home_phone"
                    maxlength="14"
                    autocomplete="kt-patient-home-phone"
                    ktAppPhoneMask
                  />
                  <mat-error *ngIf="isControlHasError('home_phone', 'pattern')">
                    {{ 'PATIENT.INPUT.HOME_PHONE' | translate }}
                    <strong>{{ 'PATIENT.VALIDATION.PATTERN' | translate }}</strong>
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-2 kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid gl-block" appearance="fill">
                  <mat-label>Office Number</mat-label>
                  <input
                    matInput
                    placeholder="Enter Office Number"
                    ktAppPhoneMask
                    formControlName="office_number"
                    autocomplete="kt-patient-office-number"
                  />
                </mat-form-field>
              </div>
              <div class="col-lg-2 kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid gl-block" appearance="fill">
                  <mat-label>Extension</mat-label>
                  <input
                    matInput
                    placeholder="Enter Extension"
                    formControlName="extension"
                    maxlength="7"
                    autocomplete="kt-patient-extension"
                  />
                  <mat-hint><strong>Must be less than 7 digit</strong></mat-hint>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <h5 class="font-weight-bold mb-6">Address</h5>
            </div>
            <div class="form-group row">
              <div class="col-lg-12 kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid gl-block" appearance="fill">
                  <mat-label>{{ 'DOCTOR.INPUT.URBANIZATION' | translate }}</mat-label>
                  <input
                    matInput
                    formControlName="urbanization"
                    [ngModel]="urbanizationValue"
                    autocomplete="kt-patient-urbanization"
                    (ngModelChange)="urbanizationValue = $event ? $event.toUpperCase() : ''"
                  />
                  <mat-error *ngIf="isControlHasError('urbanization', 'maxlength')">
                    Maximum length is 48 character
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-12 kt-margin-bottom-20-mobile">
                <mat-form-field appearance="fill" class="mat-form-field-fluid gl-block">
                  <mat-label translate="CONTACT.FORM.ADDRESS1">Address1</mat-label>
                  <input
                    matInput
                    formControlName="address_1"
                    [ngModel]="Address1Value"
                    autocomplete="kt-patient-address-1"
                    (ngModelChange)="Address1Value = $event ? $event.toUpperCase() : ''"
                    required
                  />
                  <mat-error *ngIf="isControlHasError('address_1', 'maxlength')">
                    Maximum length is 48 character
                  </mat-error>
                  <mat-error *ngIf="isControlHasError('address_1', 'required')">
                    Address1 is required
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-12 kt-margin-bottom-20-mobile">
                <mat-form-field appearance="fill" class="mat-form-field-fluid gl-block">
                  <mat-label translate="CONTACT.FORM.ADDRESS2">Address2</mat-label>
                  <input
                    matInput
                    formControlName="address_2"
                    [ngModel]="Address2Value"
                    autocomplete="kt-patient-address-2"
                    (ngModelChange)="Address2Value = $event ? $event.toUpperCase() : ''"
                  />
                  <mat-error *ngIf="isControlHasError('address_2', 'maxlength')">
                    Maximum length is 48 character
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field appearance="fill" class="mat-form-field-fluid gl-block">
                  <mat-label translate="CONTACT.FORM.CITY">City</mat-label>
                  <input
                    matInput
                    formControlName="city"
                    [ngModel]="cityValue"
                    autocomplete="kt-patient-city"
                    (ngModelChange)="cityValue = $event ? $event.toUpperCase() : ''"
                    required
                  />
                  <mat-error *ngIf="isControlHasError('city', 'maxlength')">
                    Maximum length is 30 character
                  </mat-error>
                  <mat-error *ngIf="isControlHasError('city', 'required')">
                    City is required
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field appearance="fill" class="mat-form-field-fluid">
                  <mat-label translate="CONTACT.FORM.STATE">State</mat-label>
                  <mat-select formControlName="state" required>
                    <mat-option value="AL">AL</mat-option>
                    <mat-option value="AK">AK</mat-option>
                    <mat-option value="AR">AR</mat-option>
                    <mat-option value="AZ">AZ</mat-option>
                    <mat-option value="CA">CA</mat-option>
                    <mat-option value="CO">CO</mat-option>
                    <mat-option value="CT">CT</mat-option>
                    <mat-option value="DC">DC</mat-option>
                    <mat-option value="DE">DE</mat-option>
                    <mat-option value="FL">FL</mat-option>
                    <mat-option value="GA">GA</mat-option>
                    <mat-option value="HI">HI</mat-option>
                    <mat-option value="IA">IA</mat-option>
                    <mat-option value="ID">ID</mat-option>
                    <mat-option value="IL">IL</mat-option>
                    <mat-option value="IN">IN</mat-option>
                    <mat-option value="KS">KS</mat-option>
                    <mat-option value="KY">KY</mat-option>
                    <mat-option value="LA">LA</mat-option>
                    <mat-option value="MA">MA</mat-option>
                    <mat-option value="MD">MD</mat-option>
                    <mat-option value="ME">ME</mat-option>
                    <mat-option value="MI">MI</mat-option>
                    <mat-option value="MN">MN</mat-option>
                    <mat-option value="MO">MO</mat-option>
                    <mat-option value="MS">MS</mat-option>
                    <mat-option value="MT">MT</mat-option>
                    <mat-option value="NC">NC</mat-option>
                    <mat-option value="NE">NE</mat-option>
                    <mat-option value="NH">NH</mat-option>
                    <mat-option value="NJ">NJ</mat-option>
                    <mat-option value="NM">NM</mat-option>
                    <mat-option value="NV">NV</mat-option>
                    <mat-option value="NY">NY</mat-option>
                    <mat-option value="ND">ND</mat-option>
                    <mat-option value="OH">OH</mat-option>
                    <mat-option value="OK">OK</mat-option>
                    <mat-option value="OR">OR</mat-option>
                    <mat-option value="PA">PA</mat-option>
                    <mat-option value="PR">PR</mat-option>
                    <mat-option value="RI">RI</mat-option>
                    <mat-option value="SC">SC</mat-option>
                    <mat-option value="SD">SD</mat-option>
                    <mat-option value="TN">TN</mat-option>
                    <mat-option value="TX">TX</mat-option>
                    <mat-option value="UT">UT</mat-option>
                    <mat-option value="VT">VT</mat-option>
                    <mat-option value="VA">VA</mat-option>
                    <mat-option value="WA">WA</mat-option>
                    <mat-option value="WI">WI</mat-option>
                    <mat-option value="WV">WV</mat-option>
                    <mat-option value="WY">WY</mat-option>
                  </mat-select>
                  <mat-error *ngIf="isControlHasError('state', 'required')">
                    State is required
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field appearance="fill" class="mat-form-field-fluid gl-block">
                  <mat-label translate="CONTACT.FORM.ZIP">Zip</mat-label>
                  <input
                    matInput
                    formControlName="zip"
                    maxlength="10"
                    [ngModel]="zipValue"
                    autocomplete="kt-patient-zip-code"
                    (ngModelChange)="zipValue = $event ? putDash($event) : ''"
                    required
                  />
                  <mat-error *ngIf="isControlHasError('zip', 'required')">
                    Zip Code is required
                  </mat-error>
                  <mat-error *ngIf="isControlHasError('zip', 'pattern')">
                    Zip Code is invalid
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <h5 class="font-weight-bold mb-6">Other Details</h5>
            </div>
            <div class="form-group row">
              <div class="form-group col-lg-12 row pr-0">
                <div class="col-lg-2 kt-margin-bottom-20-mobile">
                  <div class="checkbox-list">
                    <label class="checkbox">
                      <input
                        type="checkbox"
                        formControlName="hold_flag"
                        [(ngModel)]="holdChecked"
                        autocomplete="kt-patient-hold-flag"
                      />
                      <span></span>
                      {{ 'PATIENT.INPUT.HOLD_FLAG' | translate }}
                    </label>
                  </div>
                </div>
                <div class="col-lg-3 kt-margin-bottom-20-mobile">
                  <mat-form-field class="mat-form-field-fluid" appearance="fill">
                    <mat-label>{{ 'PATIENT.INPUT.HOLD_DATE' | translate }}</mat-label>
                    <input
                      matInput
                      [matDatepicker]="hold_date"
                      formControlName="hold_date"
                      [readonly]="!holdChecked"
                      ktDateMaskControl
                      maxlength="10"
                      placeholder="MM/DD/YYYY"
                      autocomplete="kt-patient-hold-date"
                    />
                    <mat-datepicker-toggle
                      matSuffix
                      [for]="hold_date"
                      [disabled]="!holdChecked"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #hold_date></mat-datepicker>
                    <mat-error
                      >{{ 'PATIENT.INPUT.HOLD_DATE' | translate }}
                      <strong>{{ 'PATIENT.VALIDATION.INVALID' | translate }}</strong>
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-lg-7 kt-margin-bottom-20-mobile">
                  <mat-form-field class="mat-form-field-fluid" appearance="fill">
                    <mat-label>{{ 'PATIENT.INPUT.HOLD_NOTE' | translate }}</mat-label>
                    <textarea
                      matInput
                      placeholder="Enter Hold Note"
                      formControlName="hold_note"
                      rows="1"
                      autocomplete="kt-patient-hold-note"
                      [readonly]="!holdChecked"
                    ></textarea>
                    <mat-error
                      >{{ 'PATIENT.INPUT.HOLD_NOTE' | translate }}
                      <strong>{{ 'PATIENT.VALIDATION.INVALID' | translate }}</strong>
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="form-group col-lg-12 row pr-0">
                <div class="col-lg-2 kt-margin-bottom-20-mobile">
                  <div class="checkbox-list">
                    <label class="checkbox">
                      <input
                        type="checkbox"
                        formControlName="in_hospital"
                        [(ngModel)]="hospitalChecked"
                        autocomplete="kt-patient-in-hospital"
                      />
                      <span></span>
                      {{ 'PATIENT.INPUT.IN_HOSPITAL' | translate }}
                    </label>
                  </div>
                </div>
                <div class="col-lg-3 kt-margin-bottom-20-mobile">
                  <mat-form-field class="mat-form-field-fluid" appearance="fill">
                    <mat-label>{{ 'PATIENT.INPUT.IN_HOSPITAL_DATE' | translate }}</mat-label>
                    <input
                      matInput
                      [matDatepicker]="in_hospital_date"
                      formControlName="in_hospital_date"
                      ktDateMaskControl
                      maxlength="10"
                      placeholder="MM/DD/YYYY"
                      autocomplete="kt-patient-in-hospital-date"
                      [readonly]="!hospitalChecked"
                    />
                    <mat-datepicker-toggle
                      matSuffix
                      [for]="in_hospital_date"
                      [disabled]="!hospitalChecked"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #in_hospital_date></mat-datepicker>
                    <mat-error
                      >{{ 'PATIENT.INPUT.IN_HOSPITAL_DATE' | translate }}
                      <strong>{{ 'PATIENT.VALIDATION.INVALID' | translate }}</strong>
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-lg-7 row kt-margin-bottom-20-mobile mx-0 px-0">
                  <div
                    *ngIf="patient.id && measurementSystem === 'm'"
                    class="col-lg-4 kt-margin-bottom-20-mobile"
                  >
                    <mat-form-field class="mat-form-field-fluid" appearance="fill">
                      <button
                        matSuffix
                        mat-icon-button
                        matTooltip="{{ 'PATIENT.INPUT.WEIGHT_HISTORY' | translate }}"
                        (click)="expandWeightHistory(patient)"
                      >
                        <mat-icon>open_in_new</mat-icon>
                      </button>
                      <mat-label> {{ 'PATIENT.INPUT.WEIGHT_KG' | translate }}</mat-label>
                      <input
                        matInput
                        placeholder="Enter weight"
                        formControlName="weight_kg"
                        [(ngModel)]="weight_kg"
                        autocomplete="kt-patient-weight-kg"
                        readonly
                      />
                      <mat-error
                        >{{ 'PATIENT.INPUT.WEIGHT_KG' | translate }}
                        <strong>{{ 'PATIENT.VALIDATION.REQUIRED' | translate }}</strong>
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div
                    *ngIf="patient.id && measurementSystem === 'i'"
                    class="col-lg-4 kt-margin-bottom-20-mobile"
                  >
                    <mat-form-field class="mat-form-field-fluid" appearance="fill">
                      <button
                        matSuffix
                        mat-icon-button
                        matTooltip="{{ 'PATIENT.INPUT.WEIGHT_HISTORY' | translate }}"
                        (click)="expandWeightHistory(patient)"
                      >
                        <mat-icon>open_in_new</mat-icon>
                      </button>
                      <mat-label>{{ 'PATIENT.INPUT.WEIGHT_LB' | translate }}</mat-label>
                      <input
                        matInput
                        placeholder="Enter weight"
                        formControlName="weight_lb"
                        [(ngModel)]="weight_lb"
                        autocomplete="kt-patient-weight-lb"
                        readonly
                      />
                      <mat-error
                        >{{ 'PATIENT.INPUT.WEIGHT_LB' | translate }}
                        <strong>{{ 'PATIENT.VALIDATION.REQUIRED' | translate }}</strong>
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div
                    *ngIf="patient.id && measurementSystem === 'i'"
                    class="col-lg-4 kt-margin-bottom-20-mobile"
                  >
                    <mat-form-field class="mat-form-field-fluid" appearance="fill">
                      <button
                        matSuffix
                        mat-icon-button
                        matTooltip="{{ 'PATIENT.INPUT.HEIGHT_HISTORY' | translate }}"
                        (click)="expandHeightHistory(patient)"
                      >
                        <mat-icon>open_in_new</mat-icon>
                      </button>
                      <mat-label>{{ 'PATIENT.INPUT.HEIGHT_FEET' | translate }}</mat-label>
                      <input
                        matInput
                        placeholder="Enter height feet"
                        formControlName="height_ft"
                        autocomplete="kt-patient-height-ft"
                        [(ngModel)]="height_ft"
                        readonly
                      />
                      <mat-error
                        >{{ 'PATIENT.INPUT.HEIGHT_FEET' | translate }}
                        <strong>{{ 'PATIENT.VALIDATION.REQUIRED' | translate }}</strong>
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div
                    *ngIf="patient.id && measurementSystem === 'i'"
                    class="col-lg-4 kt-margin-bottom-20-mobile"
                  >
                    <mat-form-field class="mat-form-field-fluid" appearance="fill">
                      <button
                        matSuffix
                        mat-icon-button
                        matTooltip="{{ 'PATIENT.INPUT.HEIGHT_HISTORY' | translate }}"
                        (click)="expandHeightHistory(patient)"
                      >
                        <mat-icon>open_in_new</mat-icon>
                      </button>
                      <mat-label>{{ 'PATIENT.INPUT.HEIGHT_INCH' | translate }}</mat-label>
                      <input
                        matInput
                        placeholder="Enter height inch"
                        formControlName="height_in"
                        autocomplete="kt-patient-height-in"
                        [(ngModel)]="height_in"
                        readonly
                      />
                      <mat-error
                        >{{ 'PATIENT.INPUT.HEIGHT_INCH' | translate }}
                        <strong>{{ 'PATIENT.VALIDATION.REQUIRED' | translate }}</strong>
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div
                    *ngIf="patient.id && measurementSystem === 'm'"
                    class="col-lg-4 kt-margin-bottom-20-mobile"
                  >
                    <mat-form-field class="mat-form-field-fluid" appearance="fill">
                      <button
                        matSuffix
                        mat-icon-button
                        matTooltip="{{ 'PATIENT.INPUT.HEIGHT_HISTORY' | translate }}"
                        (click)="expandHeightHistory(patient)"
                      >
                        <mat-icon>open_in_new</mat-icon>
                      </button>
                      <mat-label>{{ 'PATIENT.INPUT.HEIGHT_CM' | translate }}</mat-label>
                      <input
                        matInput
                        placeholder="Enter height cm"
                        formControlName="height_cm"
                        [(ngModel)]="height_cm"
                        autocomplete="kt-patient-height-cm"
                        readonly
                      />
                      <mat-error
                        >{{ 'PATIENT.INPUT.HEIGHT_CM' | translate }}
                        <strong>{{ 'PATIENT.VALIDATION.REQUIRED' | translate }}</strong>
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <h5 class="font-weight-bold mb-6">Tags</h5>
            </div>
            <div class="form-group row">
              <div class="col-lg-12 kt-margin-bottom-20-mobile">
                <kt-tags
                  [autocompleteEntity]="'PATIENT'"
                  [controlObject]="tags"
                  [appearance]="'fill'"
                  [value]="tags$"
                  category="Entity"
                  [readOnlyValue]="tagsArr"
                  [readOnly]="isViewMode"
                ></kt-tags>
              </div>
            </div>
            <div class="row" *ngIf="patient.id">
              <h5 class="font-weight-bold mb-6">Last Modified</h5>
            </div>
            <div class="form-group row" *ngIf="patient.id">
              <div class="ml-5">
                <mat-label>{{ patient.last_modified_user }}</mat-label>
              </div>
            </div>
          </div>
          <!--end::Body-->
        </form>
        <!--end::Form-->
      </div>
      <!--begin::Card-->
      <div class="card card-custom card-stretch" *ngIf="tabs[1].active">
        <div class="until-they">
          <kt-note-list
            [entityId]="patient?.id"
            [entityType]="NoteEntityType.PATIENT"
          ></kt-note-list>
        </div>
      </div>
      <!--end::Card-->
      <!--begin::Card-->
      <div class="card card-custom card-stretch" *ngIf="tabs[2].active">
        <div class="until-they">
          <kt-patient-insurance [patient_id_for_task_list]="patient?.id"></kt-patient-insurance>
        </div>
      </div>
      <!--end::Card-->
      <!--begin::Card-->
      <div class="card card-custom card-stretch" *ngIf="tabs[3].active">
        <div class="until-they">
          <kt-prescriptions-list
            [fromPatient]="true"
            [patient_id_for_task_list]="patient?.id"
          ></kt-prescriptions-list>
        </div>
      </div>
      <!--end::Card-->
      <!--begin::Card-->
      <div class="card card-custom card-stretch" *ngIf="tabs[4].active">
        <div class="until-they">
          <kt-entity-relationships-list
            [entity_type]="'patients'"
            [entity_id]="patient?.id"
            (openList)="closeDialog($event)"
            (navigateToContact)="closeDialog($event)"
          ></kt-entity-relationships-list>
        </div>
      </div>
      <!--end::Card-->
      <!--begin::Card-->
      <div class="card card-custom card-stretch" *ngIf="tabs[5].active">
        <!--begin::Header-->
        <div class="card-header py-3">
          <div class="card-title align-items-start">
            <h3 class="card-label" style="align-self: center">Other Details</h3>
          </div>
          <div class="card-toolbar">
            <a
              href="javascript:"
              class="btn btn-primary mr-2"
              color="primary"
              (click)="onSubmit()"
              mat-raised-button
              matTooltip="Save & Continue"
            >
              <span class="hidden-mobile"> {{ 'AUTH.INPUT.SAVE' | translate }}</span>
            </a>
          </div>
        </div>
        <!--end::Header-->
        <div class="until-they">
          <div *ngIf="patient">
            <form [formGroup]="patientForm" class="form form-group-seperator-dashed">
              <div class="form-section form-section-first px-10">
                <div class="form-group row">
                  <div class="col-lg-12 card-header-doctor-form">
                    <h4>Geolocation</h4>
                  </div>
                  <div class="col-lg-4 kt-margin-bottom-20-mobile">
                    <mat-form-field class="mat-form-field-fluid" appearance="fill">
                      <mat-label>Enter a plus code,address or (Longitude,Latitude)</mat-label>
                      <input
                        matInput
                        placeholder="Enter a plus code or an address"
                        formControlName="geolocation_address"
                      />
                    </mat-form-field>
                    <mat-form-field class="mat-form-field-fluid" appearance="fill">
                      <mat-label>Plus Code</mat-label>
                      <input matInput placeholder="Plus Code" formControlName="plus_code" />
                    </mat-form-field>
                    <mat-form-field class="mat-form-field-fluid" appearance="fill">
                      <mat-label>Latitude</mat-label>
                      <input matInput placeholder="Latitude" formControlName="latitude" />
                    </mat-form-field>
                    <mat-form-field class="mat-form-field-fluid" appearance="fill">
                      <mat-label>Longitude</mat-label>
                      <input matInput placeholder="Longitude" formControlName="longitude" />
                    </mat-form-field>
                    <a
                      (click)="searchForGeolocation()"
                      class="btn btn-primary"
                      color="primary"
                      mat-raised-button
                      matTooltip="Find GeoLocation"
                    >
                      <span class="hidden-mobile">Find GeoLocation</span>
                    </a>
                    <a
                      (click)="resetGeolocation()"
                      class="ml-2 btn btn-secondary"
                      mat-raised-button
                      matTooltip="Reset"
                    >
                      <span class="hidden-mobile">Reset</span>
                    </a>
                  </div>
                  <div class="col-lg-8 kt-margin-bottom-20-mobile">
                    <agm-map
                      [zoom]="15"
                      [latitude]="patientForm.get('latitude').value"
                      [longitude]="patientForm.get('longitude').value"
                    >
                      <agm-marker
                        [latitude]="patientForm.get('latitude').value"
                        (dragEnd)="markerDragEnd($event)"
                        [longitude]="patientForm.get('longitude').value"
                        [markerDraggable]="true"
                      ></agm-marker>
                    </agm-map>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <!--end::Card-->
      <!--begin::Card-->
      <div *ngIf="tabs[6].active" class="card card-custom card-stretch">
        <div class="until-they">
          <kt-document-list [entityId]="patient?.id"></kt-document-list>
        </div>
      </div>
      <!--end::Card-->
      <!--begin::Card-->
      <div class="card card-custom card-stretch" *ngIf="tabs[7].active">
        <div class="until-they">
          <kt-portlet>
            <kt-portlet-header title="Task list" [class]="'card-head-lg'"> </kt-portlet-header>
            <kt-portlet-body style="padding: 0">
              <kt-task-list
                [canvasShow]="true"
                [fromPatient]="true"
                [patient_id_for_task_list]="patient?.id"
              ></kt-task-list>
            </kt-portlet-body>
          </kt-portlet>
        </div>
      </div>
      <!--end::Card-->
      <!--begin::Card-->
      <div class="card card-custom card-stretch" *ngIf="tabs[8].active">
        <div class="until-they">
          <kt-portlet>
            <kt-portlet-body style="overflow-y: scroll; max-height: 89vh; padding: 0">
              <div class="mat-table-wrapper">
                <kt-med-review-list [patientId]="patient?.id" [fromPatient]="true">
                </kt-med-review-list>
              </div>
            </kt-portlet-body>
          </kt-portlet>
        </div>
      </div>
      <!--end::Card-->
      <!--begin::Card-->
      <div class="card card-custom card-stretch" *ngIf="tabs[9].active">
        <div class="until-they">
          <kt-patient-history
            [canvasShow]="true"
            [patient_id_for_task_list]="patient?.id"
          ></kt-patient-history>
        </div>
      </div>
      <div *ngIf="tabs[10].active" class="card card-custom card-stretch">
        <div class="until-they">
          <kt-patient-devices-list [patientId]="patient"></kt-patient-devices-list>
        </div>
      </div>
      <div *ngIf="tabs[11].active" class="card card-custom card-stretch">
        <div class="until-they">
          <kt-affiliations-list></kt-affiliations-list>
        </div>
      </div>
      <!--end::Card-->
    </div>
    <!--end::Content-->
  </div>
  <!--end::Profile Personal Information-->
</div>
